// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.block-embed{padding:30px 20px 30px 20px;display:flex;justify-content:center;flex-direction:column}`, "",{"version":3,"sources":["webpack://./resources/app/modules/course/CourseBuilder/Blocks/EmbedBlock/index.scss"],"names":[],"mappings":"AAAA,aACI,2BAAA,CACA,YAAA,CACA,sBAAA,CACA,qBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
